import { logger } from "../../utils/logger.es.js";
import { sharedServicesUrl } from "../../utils/sharedServiceUrl.es.js";
const makeRequest = async (url, body) => {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify(body)
  };
  try {
    const response = await fetch(url, requestOptions);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    return await response.json();
  } catch (error) {
    logger.error("IDCSS Service request failed:", error);
    throw error;
  }
};
const createIdcsSession = async (data) => {
  const endpoint = sharedServicesUrl ? "/api/v1/idcsSession" : "/ss-horizon/api/v1/idcsSession";
  const requestUrl = sharedServicesUrl ? `${sharedServicesUrl}${endpoint}` : endpoint;
  return makeRequest(requestUrl, data);
};
const updateIdcsSession = async (sessionId, data) => {
  console.log(sharedServicesUrl);
  const endpoint = sharedServicesUrl ? `/api/v1/idcsSession/session/${sessionId}` : `/ss-horizon/api/v1/idcsSession/session/${sessionId}`;
  const requestUrl = sharedServicesUrl ? `${sharedServicesUrl}${endpoint}` : endpoint;
  return makeRequest(requestUrl, data);
};
export {
  createIdcsSession,
  updateIdcsSession
};
